export const CLASSPREFIX = 'muze';
export const IDFIELD = '__id__';
export const GRID_LINE_PARENT_GROUP_CLASS = 'grid-lines';
export const GRID_BAND_PARENT_GROUP_CLASS = 'grid-bands';
export const GRID_PARENT_GROUP = 'grid-parent-group';
export const BAND = 'band';
export const TICK = 'tick';
export const GRID_BAND = 'gridBands';
export const GRID_LINE = 'gridLines';
export const CONSOLIDATED = 'consolidated';
export const FRAGMENTED = 'fragmented';
export const FACET_BY_FIELDS = 'facetByFields';
export const RETINAL_FIELDS = 'retinalFields';
export const PARENT_ALIAS = 'parentAlias';
export const LAYERS = 'layers';
export const CACHED_DATA = 'cachedData';
export const STORE = 'store';
